import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { FC } from 'react';
import { COLORS } from 'shared/consts';

type DiaryEditCellProps = {
  onClick: () => void;
} 

export const DiaryEditCell: FC<DiaryEditCellProps> = ({
  onClick
}) => {
  return (
    <Button 
      variant='ghost'
      colorScheme='neutral'
      iconSuffix={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M12.1605 3.91328L11.5239 3.21863C11.2778 2.95009 10.8617 2.9288 10.5894 3.17083L9.5476 4.09708L11.0797 5.78845L12.1143 4.85986C12.3904 4.61212 12.4111 4.18672 12.1605 3.91328ZM3.66675 9.32542L8.80021 4.76154L10.3355 6.4564L5.27124 11.0016H3.66675V9.32542ZM12.8977 3.23763L12.2611 2.54297C11.6458 1.87162 10.6056 1.81841 9.92502 2.42347L2.89046 8.67751C2.74816 8.80402 2.66675 8.98534 2.66675 9.17575V11.3349C2.66675 11.7031 2.96522 12.0016 3.33341 12.0016H5.39889C5.56327 12.0016 5.72185 11.9409 5.84419 11.8311L12.7823 5.60408C13.4724 4.98473 13.5243 3.92123 12.8977 3.23763ZM13.3334 12.9999H2.66675V13.9999H13.3334V12.9999Z" fill={COLORS.NEUTRAL.DEFAULT}/></svg>}
      onClick={onClick}
    />
  )
}